// extracted by mini-css-extract-plugin
export default {"pathColor":"UiTour_HeaderImage_pathColor"};